import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

//components
import ManageTableWithDynamicPagination from "../../../Components/TableTemplate/ManageTableWithDynamicPagination";
import Navbar from "../../../Components/Navbar/Navbar";
import DeleteModal from "../../../Components/Modals/DeleteModal";
import AddModal from "../../../Components/Modals/AddModal";
import EditModal from "../../../Components/Modals/EditModal";
import ViewModal from "../../../Components/Modals/ViewModal";
import InputError from "../../../Components/InputError/InputError";

//css
import "./../Manage.css";
import "../../../Components/Navbar/Navbar.css";
import { isAdmin, refreshPage, toastStyle } from "../../../Helpers/Utils/Common";
import { validateDepartment } from "../../../Helpers/Validation/Manage/ForwardersValidation";
import toast from "react-hot-toast";
import { createDepartment, deleteDepartment, getDepartment, updateDepartment } from "../../../Helpers/apiCalls/departmentApi";
import Footer from "../../../Components/Footer/Footer";

export default function Departments() {
    const [inactive, setInactive] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [filterConfig, setFilterConfig] = useState({
        page: 1,
    });
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    // MODALS //
    // DELETE
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // VIEW
    const [showViewModal, setShowViewModal] = useState(false);
    const handleShowViewModal = () => setShowViewModal(true);
    const handleCloseViewForwarderModal = () =>
        setShowViewModal(false);

    // EDIT
    const [showEditModal, setShowEditModal] = useState(false);
    const handleShowEditModal = () => setShowEditModal(true);
    const handleCloseEditForwarderModal = () =>
        setShowEditModal(false);

    // ADD
    const [showAddModal, setShowAddModal] = useState(false);
    const handleShowAddModal = () => setShowAddModal(true);
    const handleCloseAddForwarderModal = () => setShowAddModal(false);

    //API
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [addDetails, setAddDetails] = useState({
        name: "",
        address: " ",
        phone_no: "",
    });

    //REQUIRED ERROR HANDLING
    const [isError, setIsError] = useState({
        name: false,
    });

    const [isErrorEdit, setIsErrorEdit] = useState({
        name: false,
    });

    //ONCHANGE
    //ADD or CREATE FORWARDER
    const handleAddChange = (e) => {
        const { name, value } = e.target;
        setAddDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    //onEdit
    function handleOnEdit() {
        handleCloseViewForwarderModal();
        handleShowEditModal();
    }

    //EDIT OR UPDATE FORWARDER
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setAddDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    //DELETE or REMOVE FORWARDER

    //DROPDOWN
    function handleSelectChange(e, row) {
        // fetchForwarder(row.id);
        setSelectedRow(row);
        setAddDetails(row)
        if (e.target.value === "delete") {
            handleShowDeleteModal();
        } else if (e.target.value === "edit") {
            handleShowEditModal();
        } else if (e.target.value === "view") {
            handleShowViewModal();
        } else {
            handleShowDeleteModal();
        }
    }

    function ActionBtn(row) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action form-select"
                id={row.id}
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option defaulValue selected hidden>
                    Select
                </option>
                <option value="view" className="color-options">
                    View
                </option>
                {isAdmin && (
                    <option value="edit" className="color-options">
                        Edit
                    </option>
                )}
                {isAdmin && (
                    <option value="delete" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }

    //API CALL
    async function fetchDepartment() {
        setShowLoader(true);
        const response = await getDepartment(filterConfig);
        if (response.data) {
            var sortedData = response.data.data.sort((a, b) =>
                a.name > b.name
                    ? 1
                    : b.name > a.name
                    ? -1
                    : 0
            );
            sortedData.map((data)=>{
                return{
                    name: data.name,
                }
            })
            setTableData(sortedData);
            setTotalItems(response.data.size);
        } 
        else {
            setTableData([]);
            setTotalItems(0);
        }
        setShowLoader(false);
    }


    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    // async function fetchForwarder(id) {
    //     const response = await getForwarder(id);
    //     if (response.data.data) {
    //         var forwarder = response.data.data[0];
    //         setAddDetails(forwarder);
    //     } else {
    //         setAddDetails({});
    //     }
    // }

    async function handleSaveDepartment() {
        if (validateDepartment(addDetails, setIsError)) {
            setIsClicked(true);

            const response = await createDepartment(addDetails);
            if (response.data) {
                toast.success("Successfully created department!", {
                    style: toastStyle(),
                });
                handleCloseAddForwarderModal();
                refreshPage();
            } else {
                toast.error(response.error.response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
        } else {
            toast.error("Please fill in all fields!", { style: toastStyle() });
        }
    }

    async function handleEditDepartment() {
        if (validateDepartment(addDetails, setIsErrorEdit)) {
            setIsClicked(true);
            const response = await updateDepartment(addDetails);
            if (response.data) {
                toast.success("Successfully updated department!", {
                    style: toastStyle(),
                });
                handleCloseEditForwarderModal();
                refreshPage();
            } else {
                toast.error(response.error.data.messages.error, {
                    style: toastStyle(),
                });
            }
        } else {
            toast.error("Please fill in all fields!", { style: toastStyle() });
        }
    }

    async function handleDeleteDepartment() {
        setIsClicked(true);
        const response = await deleteDepartment(selectedRow.id);
        if (response.data) {
            toast.success("Successfully deleted department!", {
                style: toastStyle(),
            });
            handleCloseDeleteModal();
            refreshPage();
        } else {
            toast.error(response.error.data.messages.error, {
                style: toastStyle(),
            });
        }
    }

    useEffect(() => {
        fetchDepartment();
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PAYROLL"}
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> DEPARTMENTS </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            className="search-bar"
                            defaultValue=""
                            placeholder="Search name..."
                            name="name"
                            // onChange={(e) => handleOnSearch(e)}
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") &&
                                handleOnSearch(e)
                            }
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                        <button
                            className="add-btn"
                            onClick={handleShowAddModal}
                        >
                            Add
                        </button>
                        </div>
                    </Col>
                </Row>
                <div className="tab-content">
                    {/* TABLE */}
                    <ManageTableWithDynamicPagination
                        tableHeaders={["NAME", "DESCRIPTION", "ACTIONS"]}
                        headerSelector={["name", "description"]}
                        tableData={tableData}
                        ActionBtn={(row) => ActionBtn(row)}
                        showLoader={showLoader}
                        // used in dynamic pagination
                        totalItems={totalItems}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        handlePageChange={handlePageChange}
                    />
                </div>
            </div>

            {/* MODALS */}
            <DeleteModal
                text="department"
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onDelete={handleDeleteDepartment}
                isClicked={isClicked}
            />
            <AddModal
                title="DEPARTMENT"
                size="lg"
                type="department"
                show={showAddModal}
                onHide={handleCloseAddForwarderModal}
                onSave={handleSaveDepartment}
                isClicked={isClicked}
            >
                <div className="mt-3">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col>
                            NAME
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="name"
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.name}
                                message={"Name is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>
                            DESCRIPTION
                            <Form.Control
                                type="text"
                                name="description"
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                </div>
            </AddModal>
            <EditModal
                title="DEPARTMENT"
                size="lg"
                type="forwarder"
                show={showEditModal}
                onHide={handleCloseEditForwarderModal}
                onSave={handleEditDepartment}
                isClicked={isClicked}
            >
                <div className="mt-3">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col>
                            NAME
                            <Form.Control
                                type="text"
                                name="name"
                                defaultValue={addDetails.name}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                            <InputError
                                isValid={isErrorEdit.name}
                                message={"Name is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>
                            DESCRIPTION
                            <Form.Control
                                type="text"
                                name="description"
                                defaultValue={addDetails.description}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                </div>
            </EditModal>
            <ViewModal
                withButtons
                show={showViewModal}
                onHide={handleCloseViewForwarderModal}
                onEdit={handleOnEdit}
            >
                <div>
                    <div className="col-sm-12 space">
                        <span className="custom-modal-body-title-forwarder-details">
                            DEPARTMENT DETAILS
                        </span>
                        <div className="container-wrapper">
                            <Row className="nc-modal-custom-row-view">
                                <Col className="nc-modal-custom-row-details">
                                    NAME
                                    <Row className="nc-modal-custom-row">
                                        <Col> {addDetails.name}</Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="nc-modal-custom-row-view">
                                <Col className="nc-modal-custom-row-details">
                                    DESCRIPTION
                                    <Row className="nc-modal-custom-row">
                                        <Col>{addDetails.description}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </ViewModal>
            <Footer/>
        </div>
    );
}
